import { apiRequest } from "../utils/useAPIRequest";
import constant from "../utils/constant";
import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";
import { queryClient } from "../App";

const useGetPayout = (PayoutTableQuery, filterQuery, searchQuery) => {
  const query = useMemo(() => {
    if (searchQuery && filterQuery) {
      return `${PayoutTableQuery}&${filterQuery}&search=${searchQuery}`;
    } else if (searchQuery) {
      return `${PayoutTableQuery}&search=${searchQuery}`;
    } else if (filterQuery) {
      return `${PayoutTableQuery}&${filterQuery}`;
    } else {
      return PayoutTableQuery;
    }
  }, [filterQuery, PayoutTableQuery, searchQuery]);

  return useQuery({
    queryKey: ["getPayout", query],
    queryFn: () => {
      return apiRequest({
        url: `/marketers/marketer-payout?${query}`,
        method: "get",
      });
    },
    keepPreviousData: true,
  });
};

const createPayout = async (payload) => {
  const { status, data, errorMessage } = await apiRequest({
    url: "/marketers/marketer-payout",
    method: "post",
    payload,
  });
  if (status === constant.Success) {
    queryClient.invalidateQueries({ queryKey: ["getPayout"] });
    return { status, data };
  }
  return { status, data, errorMessage };
};

const approvePayout = async (payload) => {
  const { status, data, errorMessage } = await apiRequest({
    url: "/marketers/approve-marketer-payout",
    method: "post",
    payload,
  });
  if (status === constant.Success) {
    queryClient.invalidateQueries({ queryKey: ["getPayout"] });
    return { status, data };
  }
  return { status, data, errorMessage };
};
const ignorePayout = async (payload) => {
  const { status, data, errorMessage } = await apiRequest({
    url: "/marketers/set-ignore-or-pending",
    method: "post",
    payload,
  });
  if (status === constant.Success) {
    queryClient.invalidateQueries({ queryKey: ["getPayout"] });
    return { status, data };
  }
  return { status, data, errorMessage };
};

export default {
  useGetPayout,
  createPayout,
  approvePayout,
  ignorePayout,
};
